/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { keyBy } from 'lodash';
import mime from 'mime-types';

import Alert from '../../../Common/AlertContainer';
import Error from '../../../Common/Error';
import { commonStyle } from '../../../Common/CommonStyle';
import BuxService from '../../../../Service/BuxService';
import { getDate, getYear, getMonth } from 'date-fns';
import { LogError } from '../../../../AppUtil/AppUtil';
import UserService from '../../../../Service/UserService';
import Session from '../../../../Service/Session';
import MobileFooter from '../../Profile/MobileFooter';
import InputLabelMobile from '../../Profile/InputLabelMobile';
import PageHeaderTitle from '../../Profile/PageHeaderTitle';

const APP_STRING = window.AppStrings;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_error: null,
			_errorFromEdit: '',
			_isResendingOtp: false,
			_isOptSubmitBtnLoaderOn: false,
			allowResendOtp: false,
			otp: '',
			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			}
		};
	}

	otpChangeHandler(otp, _type) {
		this.setState({
			otp: otp.target.value,
			_error: null
		});
	}

	getOtp() {
		const otp = this.state.otp;
		return otp.toString();
	}

	resetOtpForm = () => {
		this.setState({
			otp: ''
		});
	};

	getcontactSuffix(phone) {
		return phone.slice(3);
	}

	createWallet = async () => {
		const contactSuffix = this.getcontactSuffix(this.props.currentUser.profile.phone);
		const walletPayload = {
			email: this.props.dwollaSignUpForm.emailId.value,
			contact: contactSuffix,
			first_name: this.props.dwollaSignUpForm.firstName.value,
			last_name: this.props.dwollaSignUpForm.lastName.value
		};
		try {
			return await BuxService.buxCreateWallet(walletPayload);
		} catch (err) {
			LogError(err.message);
		}
	};

	createFile = async (url, fileName) => {
		const response = await fetch(url);
		const blob = await response.blob();
		const metadata = { type: mime.lookup(fileName) };
		const file = new File([blob], fileName, metadata);
		return file;
	};

	onsubmitFormHandler = async e => {
		e.preventDefault();
		const otp = this.getOtp();
		if (otp.length !== 6) {
			this.setState({
				_error: 'error_message.invalid_code'
			});
			return false;
		}
		this.setState({
			_isOptSubmitBtnLoaderOn: true
		});
		try {
			const payload = {
				Recipient: this.props.dwollaSignUpForm.emailId.value,
				Code: otp
			};
			const response = await BuxService.getEmailVerify(payload);
			if (response) {
				const userInfo = {
					...this.props.dwollaSignUpForm
				};

				const updateUser = {
					email: userInfo.emailId.value,
					id_type: userInfo.idType.value,
					id_number: userInfo.idNumber.value,
					address: userInfo.address.value,
					city: userInfo.city.value,
					dob: this.getDateFormat(userInfo.dob.value),
					wallet_connected: true
				};

				const wallet = await this.createWallet();
				localStorage.setItem('WALLET', JSON.stringify(wallet));

				if (!wallet) {
					this.toastFail('Email already have wallet please try again with different email!');
					this.setState({ _isOptSubmitBtnLoaderOn: false });
					return;
				}

				const user = await UserService.updateUserInfo(updateUser);

				if (!user) {
					this.toastSuccess('User was not able to update!');
					this.setState({
						_isOptSubmitBtnLoaderOn: false
					});
					return;
				}
				this.toastSuccess('Wallet created successfully!');
				this.props.oncloseOtp();
				this.setState({
					_isOptSubmitBtnLoaderOn: false
				});
			} else {
				this.setState({
					otp: '',
					_error: 'error_message.invalid_code',
					_isOptSubmitBtnLoaderOn: false
				});
			}
		} catch (err) {
			LogError(err.message);
		}
	};

	resendOtp = async () => {
		this.setState({
			_isResendingOtp: true
		});
		const message = 'signin.code_sent_successfully_email';
		try {
			this.sendOtp();
			this.showAlert(true, 'success', message);
			this.setState({
				_isResendingOtp: false
			});
		} catch (err) {
			this.showAlert(true, 'error', 'error_message.something_went_wrong');
			this.setState({
				_isResendingOtp: false
			});
		}
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	getDateFormat(dob) {
		const dobDate = getDate(dob);
		const dobMonth = getMonth(dob) + 1;
		const dobYear = getYear(dob);
		return `${dobYear}-${dobMonth}-${dobDate}`;
	}

	toastFail = msg => {
		Swal.fire({
			title: 'Error',
			text: msg,
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			confirmButtonText: 'Try again',
			customClass: 'otp_message_success'
		});
	};

	toastSuccess = msg => {
		Swal.fire({
			animation: false,
			title: 'Success',
			text: msg,
			icon: 'success',
			confirmButtonText: 'Okay',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				window.location.reload();
			}
		});
	};

	sendOtp = async () => {
		const requestBody = {
			ValidIdNumber: this.props.dwollaSignUpForm.idNumber.value,
			ValidIdType: this.props.dwollaSignUpForm.idType.value.value,
			DateOfBirth: this.getDateFormat(this.props.dwollaSignUpForm.dob.value),
			PhysicalAddress: `${this.props.dwollaSignUpForm.address.value} ${this.props.dwollaSignUpForm.city.value}`,
			LastName: this.props.dwollaSignUpForm.lastName.value,
			FirstName: this.props.dwollaSignUpForm.firstName.value,
			EmailAddress: this.props.dwollaSignUpForm.emailId.value
		};
		try {
			const response = await BuxService.sendEmailVerification(requestBody);
			if (!response) {
				this.toastFail('Send OTP failed. Try resending OTP');
			}
		} catch (error) {
			LogError(error.message);
		}
	};

	componentDidMount() {
		this.sendOtp();
		this.allowResendOtp();
	}

	allowResendOtp = () => {
		let count = 0;
		const timer = setInterval(() => {
			++count;
			if (count == 59) {
				this.setState({
					allowResendOtp: true
				});
				clearInterval(timer);
			}
		}, 1000);
		this.setState({
			allowResendOtp: false
		});
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<Container component="main" className="kyc_otp_container">
				<PageHeaderTitle
					onClick={this.props.handleBackFromOtp}
					title="Verification Code"
					className="kyc_otp p-x-16"
				/>
				{/* <CssBaseline /> */}
				<Paper className={classes.paper}>
					<Grid id="full-wdith" item sm={8} xs={12} md zeroMinWidth>
						<div>
							<div className={classes.paper} id="kyc_otp-wallet">
								<Typography component="h4" gutterBottom variant="h5">
									{t('signin.text_for_otp_screen')} {t('label.email')}
								</Typography>

								<form
									noValidate
									// className="otpform"
									onSubmit={this.onsubmitFormHandler}
									style={{
										width: '185px'
									}}>
									{
										<>
											<InputLabelMobile label="6-Digit Code" />
											<TextField
												autoComplete="nope"
												className="text-center kyc_otp_input_code"
												id="outlined-basic"
												label=""
												margin="normal"
												placeholder="123456"
												onChange={otp => this.otpChangeHandler(otp)}
												value={this.state.otp}
												variant="outlined"
												inputProps={{
													style: { textAlign: 'center' }
												}}
											/>
										</>
									}
									{/* <div
										className={classes.blockdiv}
										style={{
											display: 'flex',
											justifyContent: 'space-between'
										}}>
										<Fab
											aria-label="add"
											color="primary"
											onClick={this.props.handleBackFromOtp}
											size="medium"
											variant="extended">
											{t('buttons.back')}
										</Fab>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											size="medium"
											type="submit"
											variant="extended"
											style={{ margin: 0 }}>
											{t('buttons.submit')}
											{this.state._isOptSubmitBtnLoaderOn ? (
												<CircularProgress disableShrink size={18} className="ml-2" />
											) : null}
										</Fab>
									</div> */}
								</form>
								<Error
									text={
										this.state._errorFromEdit !== ''
											? this.state._errorFromEdit
											: t(this.state._error)
									}
								/>
								<Typography component="h4" gutterBottom variant="h5" className="receive_code">
									{t('signin.didnt_recieve_code')}
								</Typography>
								<Link
									href="#"
									className="resend_code"
									style={{
										color: this.state.allowResendOtp ? '#27B88D' : 'grey',
										pointerEvents: this.state.allowResendOtp ? '' : 'none'
									}}
									onClick={_e => {
										if (this.state.allowResendOtp) {
											this.resendOtp();
											this.allowResendOtp();
										}
									}}
									variant="body2">
									{this.state._isResendingOtp ? t('label.sending') : 'Send again'}
								</Link>
							</div>
						</div>
					</Grid>
				</Paper>
				<Alert
					severity={this.state._alert._severity}
					onClose={this.hideAlert}
					message={t(this.state._alert._message)}
					show={this.state._alert._show}
				/>
				<form noValidate onSubmit={this.onsubmitFormHandler} className="otp_footer">
					<Grid sm={8} xs={12} item>
						<MobileFooter
							loading={
								this.state._isOptSubmitBtnLoaderOn ? (
									<CircularProgress disableShrink size={18} className="ml-2" />
								) : null
							}
							hasNext={true}
							htmlType="Submit"
							className="kyc_otp"
							onClick={this.props.handleBackFromOtp}
							textButtonContinue={this.state._isOptSubmitBtnLoaderOn ? null : 'SUBMIT'}
						/>
					</Grid>
				</form>
			</Container>
		);
	}
}

export default withStyles(commonStyle)(withTranslation()(index));
